import styled from 'styled-components';

export const SubCategoryHeader = styled.h2`
  display: block;
  font-weight: 600;
  text-align: left;
  color: rgba(0, 0, 0, 0.8);
  font-size: clamp(14px, 2vw, 16px);
  letter-spacing: 1.4px;
  padding: 0 12px 14px;
  text-transform: capitalize;
`;
export const HeaderRing = styled.span`
  width: 10px !important;
  height: 10px;
  border: 3px solid #f9cd47;
  border-radius: 50%;
  position: absolute;
  bottom: 25px;
  @media (max-width: 720px) {
    width: 8px !important;
    height: 8px;
    bottom: 20px;
  }
`;
export const SubCategoryImage = styled.div`
  position: relative;
  padding-top: 34%;
  margin: 0;
  span {
    position: unset !important;
  }

  img {
    object-fit: contain;
    width: 100% !important;
  }
`;
